/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An unproxied MCP server configuration
 */
export type UnproxiedMcpServer = {
  /**
   * When the unproxied MCP server was created
   */
  createdAt: Date;
  /**
   * Optional description shown alongside the server.
   */
  description?: string | undefined;
  /**
   * The ID of the unproxied MCP server
   */
  id: string;
  /**
   * Optional human-readable name for the unproxied MCP server
   */
  name?: string | undefined;
  /**
   * The project ID this unproxied MCP server belongs to
   */
  projectId: string;
  /**
   * URL-friendly slug derived from the URL and ID.
   */
  slug?: string | undefined;
  /**
   * When the unproxied MCP server was last updated
   */
  updatedAt: Date;
  /**
   * The URL of the vendor's MCP server
   */
  url: string;
};

/** @internal */
export const UnproxiedMcpServer$inboundSchema: z.ZodMiniType<
  UnproxiedMcpServer,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    description: z.optional(z.string()),
    id: z.string(),
    name: z.optional(z.string()),
    project_id: z.string(),
    slug: z.optional(z.string()),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    url: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "project_id": "projectId",
      "updated_at": "updatedAt",
    });
  }),
);

export function unproxiedMcpServerFromJSON(
  jsonString: string,
): SafeParseResult<UnproxiedMcpServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UnproxiedMcpServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UnproxiedMcpServer' from JSON`,
  );
}
